"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");

var CPPSwitchBlock = function (_1$CPPIfBlock) {
    _inherits(CPPSwitchBlock, _1$CPPIfBlock);

    function CPPSwitchBlock(condition) {
        _classCallCheck(this, CPPSwitchBlock);

        var _this = _possibleConstructorReturn(this, (CPPSwitchBlock.__proto__ || Object.getPrototypeOf(CPPSwitchBlock)).call(this));

        _this.condition = condition;
        return _this;
    }

    _createClass(CPPSwitchBlock, [{
        key: "defineCase",
        value: function defineCase(condition, body) {
            _get(CPPSwitchBlock.prototype.__proto__ || Object.getPrototypeOf(CPPSwitchBlock.prototype), "defineCondition", this).call(this, condition, body);
            return this;
        }
    }, {
        key: "defineDefault",
        value: function defineDefault(body) {
            _get(CPPSwitchBlock.prototype.__proto__ || Object.getPrototypeOf(CPPSwitchBlock.prototype), "defineElseCondition", this).call(this, body);
            return this;
        }
    }, {
        key: "write",
        value: function write(formatter, indentCount) {
            var parentSwitch = new __1.CPPCodeBlock("switch (" + this.condition + ")");
            var cases = [];
            for (var condition in this.conditions) {
                var caseBlock = new __1.CPPCodeBlock("case " + condition + ":", this.conditions[condition]);
                caseBlock.setSuffix("\nbreak;");
                cases.push(caseBlock);
                cases.push(__1.CPPHelper.createEmptyLine());
            }
            var defaultBlock = new __1.CPPCodeBlock("default:", this.elseCondition);
            if (this.elseCondition.length == 0) {
                defaultBlock.setDisableBraces(true);
                defaultBlock.setSuffix("\n" + formatter.indentation + "break;");
            } else {
                defaultBlock.setSuffix("\nbreak;");
            }
            cases.push(defaultBlock);
            parentSwitch.body = cases;
            return parentSwitch.write(formatter, indentCount);
        }
    }]);

    return CPPSwitchBlock;
}(__1.CPPIfBlock);

exports.default = CPPSwitchBlock;